import { isArray } from "lodash";

import { EntityTypeName, isEntity } from "@ds/model/entity-model";

import { isPlainObject } from "@ds/utils/type-guards/common-guards";

export enum AssetTableTypeEnum {
  Videos = "videos",
  Images = "images",
  Audio = "audio",
}

export enum ApiContentTypeEnum {
  Video = "^video",
  Image = "^image",
  Audio = "^audio",
}

export enum ContentTypeNameEnum {
  Video = "video",
  Image = "image",
  Audio = "audio",
}

export const createAssetModel = (options?: Partial<Asset>): Asset => ({
  __typename: EntityTypeName.ASSET,
  id: options?.id || 0,
  project_id: options?.project_id || 0,
  name: options?.name || "",
  key: options?.key || "",
  file_name: options?.file_name || "",
  file_size: options?.file_size || 0,
  content_type: options?.content_type || "",
});

export const isAsset = (obj: unknown): obj is Asset => isEntity(obj) && obj.__typename === EntityTypeName.ASSET;

export const isAssetArray = (obj: unknown): obj is Asset[] => isArray(obj) && obj.every(isAsset);

export const isAssetQueryOutput = (obj: unknown): obj is QueryOutput<Asset> =>
  isPlainObject(obj) && "items" in obj && isAssetArray(obj.items);
